import riasecVariants from "../data/riasecVariants.js";

export const hashString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const getFieldVariantIndex = (
  profileKey,
  userToken,
  fieldName,
  variantsCount,
) => {
  if (!profileKey || !userToken) return 0;
  const seed = `${profileKey}|${fieldName}|${userToken}`;
  return hashString(seed) % variantsCount;
};

export const buildMixedVariant = (profileKey, userToken) => {
  const profileDef = riasecVariants[profileKey];
  if (!profileDef) return null;

  const variants = profileDef.variants || [];
  const n = variants.length;
  if (n === 0) return null;

  const allFieldsSet = new Set();
  variants.forEach((v) => {
    Object.keys(v || {}).forEach((k) => {
      if (k !== "strong_suit") allFieldsSet.add(k);
    });
  });
  const fields = Array.from(allFieldsSet);

  const preferOrder = [
    "top1",
    "top2",
    "top3",
    "demotivation",
    "motivation",
    "boss",
  ];
  const orderedFields = [
    ...preferOrder.filter((f) => fields.includes(f)),
    ...fields.filter((f) => !preferOrder.includes(f)),
  ];

  const mixed = { strong_suit: profileDef.strong_suit };

  const characterStrings = [];
  const characterObjects = [];
  const chosenIndices = {};

  orderedFields.forEach((field) => {
    const idx = getFieldVariantIndex(profileKey, userToken, field, n);
    const value = (variants[idx] && variants[idx][field]) || "";
    chosenIndices[field] = idx;
    characterStrings.push(value);
    characterObjects.push({
      id: `${field}-${idx}`,
      field,
      text: value,
      variantIndex: idx,
    });
    mixed[field] = value;
  });

  if (profileDef.desc) mixed.desc = profileDef.desc;
  if (profileDef.cv_entry) mixed.cv_entry = profileDef.cv_entry;

  mixed.fieldsOrder = orderedFields;
  mixed.characterStrings = characterStrings;
  mixed.characterObjects = characterObjects;
  mixed.topThreeStrings = characterStrings.slice(0, 3);
  mixed.topThreeObjects = characterObjects.slice(0, 3);

  return mixed;
};
